<template>
  <div id="app">
    <div class="page" v-if="loading">
      <b-spinner class="spinner" variant="primary" key="primary"></b-spinner>
    </div>
    <RouterView />
    <ServerErrorDialog />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { onMounted } from "vue";
import { loaderComputed, etotemlayoutComputed, sessaoComputed } from "@/state/helpers";
import darkenColor from "@/utils/darkenColor";
import { useFirebaseStore } from "@/stores/firebase";
import { useSenhaStore } from "@/stores/senha";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },

  components: {
    ServerErrorDialog: () => import('@/components/server-error-dialog')
  },

  setup() {
    const firebaseStore = useFirebaseStore();
    const senhaStore = useSenhaStore();

    onMounted(() => {
      initFirebase();
    });

    const initFirebase = () => {
      const config = {
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
        appId: process.env.VUE_APP_FIREBASE_WEB_APP_ID,
        apiKey: process.env.VUE_APP_FIREBASE_WEB_API_KEY,
      };

      if (!config.projectId || !config.appId || !config.apiKey) return;

      firebaseStore.initFirebaseApp(config);
    };

    return {
      firebaseStore,
      senhaStore,
    };
  },

  mounted() {
    document.body.style.setProperty("--cor-fonte-etotem", "#FFFFFF");
    document.body.style.setProperty("--cor-primaria-midialab", "#382b84");
    document.body.style.setProperty(
      "--cor-primaria-midialab-rgb",
      this.hexToRgb("#382b84")
    );
  },

  watch: {
    totem: {
      handler: function (novo) {
        if (novo.idTotem && this.firebaseStore.app) {
          this.senhaStore.startSenhaTotemRealTime();
        }
      },
      deep: true,
    },

    corPadrao: {
      handler: function (novo) {
        document.body.style.setProperty("--cor-primaria-etotem", novo);
        document.body.style.setProperty(
          "--cor-primaria-etotem-rgb",
          novo && this.hexToRgb(novo)
        );
        document.body.style.setProperty(
          "--cor-primaria-darken-etotem",
          darkenColor(novo)
        );
      },
      deep: true,
      immediate: true,
    },

    corFonte: {
      handler: function (novo) {
        document.body.style.setProperty("--cor-fonte-etotem", novo);
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    ...sessaoComputed,
    ...loaderComputed,
    ...etotemlayoutComputed,
  },

  methods: {
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      let rgb = result
        ? {
            r: parseInt(result[1], 16) * 0.8,
            g: parseInt(result[2], 16) * 0.8,
            b: parseInt(result[3], 16) * 0.8,
          }
        : null;
      return rgb.r.toFixed(0) + ", " + rgb.g.toFixed(0) + ", " + rgb.b.toFixed(0);
    },
  },
};
</script>

<style scoped>
.page {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  z-index: 25;
  width: 100%;
  height: 100%;
}

.spinner {
  position: relative;
  top: 384px;
  left: 50%;
}
</style>
